// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .cursor-pointer[data-v-c469023a] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
